export const CMS_ACTION_TYPES = {
  OFFER_CHECKOUT: 'offerCheckout',
  RAF: 'referAFriend',
  YOUTUBE_VIDEO: 'youtubeVideo',
  URL: 'actionLink',
};
